// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.dropdown-item:active {\n    outline: none;\n    border: none\n}", "",{"version":3,"sources":["webpack://src/UserComponent/UserButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb;AACJ","sourcesContent":["button.dropdown-item:active {\n    outline: none;\n    border: none\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
